import OptionToggle from '~/components/OptionToggle.jsx';
import ExperimentalBadge from '~/components/ExperimentalBadge.jsx';

const NumberBookableResourcesRequiredSetting = ({
    value,
    onChange,
    className,
}) => {
    return (
        <div className={className}>
            <OptionToggle
                className="[margin-right:16px]"
                value={value > 1}
                onChange={isEnabled => {
                    onChange(isEnabled ? 2 : 1);
                }}
                title={
                    <div className="flex items-center justify-between">
                        Clients must pick two people to book with
                        <ExperimentalBadge />
                    </div>
                }
                description="For joint appointments or couples massages where two people/things are required for the one appointment"
                toggleFirst={true}
            />
        </div>
    );
};

export default NumberBookableResourcesRequiredSetting;
